import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ApplicationsConfiguration } from '@era/settings-sdk';

export type ScheduledApplicationsState = EntityState<ApplicationsConfiguration>;

export function selectId(application: ApplicationsConfiguration) {
  return `${application.locationDisplayName}-${application.environmentName}-${application.bundleIdentifier}-${application.version}`;
}

export const adapter: EntityAdapter<ApplicationsConfiguration> = createEntityAdapter<ApplicationsConfiguration>({
  selectId,
});

export const initialState: ScheduledApplicationsState = adapter.getInitialState();
